import { _ as _extends } from './_rollupPluginBabelHelpers-70862ce5.js';
import React__default from 'react';
import { NumericFormat } from 'react-number-format';
import Input from './Input.js';
import 'classnames';
import './FeedbackTooltip.js';
import 'prop-types';
import './commonPropTypes-b8a00f98.js';
import './types-377ea632.js';
import './Tooltip-63e0cd1c.js';
import '@tippy.js/react';
import './error-e6cc4025.js';
import './InputIcon-248370f0.js';
import './IconRouter.js';
import './add-fb28b503.js';
import './filter-5a572cfb.js';
import './loading-1f5748a2.js';
import './magnifying-glass-00e45963.js';
import './search-1650afd3.js';
import './down-a4c956cc.js';
import './close-thin-0bb1e64b.js';
import './tick-filled-01f90247.js';
import './helpers-b515b867.js';

/**
 * Number Format Input component renders Input component formatted with commas using
 * react-number-format https://www.npmjs.com/package/react-number-format
 */

const NumberFormatInput = props => /*#__PURE__*/React__default.createElement(Input, _extends({}, props, {
  renderInput: numberProps => {
    const {
      onValueChange,
      ...customInputProps
    } = numberProps;
    return /*#__PURE__*/React__default.createElement(NumericFormat, _extends({
      allowNegative: false,
      fixedDecimalScale: true,
      thousandSeparator: ",",
      onValueChange: ({
        formattedValue
      }) => {
        const {
          onChange
        } = customInputProps;
        if (onChange) {
          customInputProps.onChange(formattedValue);
        }
      }
    }, customInputProps));
  }
}));

export { NumberFormatInput as default };
